var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeLinkSizesWeightoutlined = function SvgTypeLinkSizesWeightoutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M18.75 6.893a4.25 4.25 0 0 1-1.25 2.89L14.785 12.5a4.24 4.24 0 0 1-3.018 1.25h-.004A4.27 4.27 0 0 1 7.5 9.363a.625.625 0 0 1 1.25.035 3.017 3.017 0 0 0 5.148 2.219l2.715-2.715a3.018 3.018 0 0 0-4.268-4.268l-.86.859a.625.625 0 0 1-.883-.884l.859-.859a4.27 4.27 0 0 1 7.289 3.143M8.516 14.505l-.86.86a3 3 0 0 1-2.14.885A3.018 3.018 0 0 1 3.384 11.1l2.71-2.715a3.018 3.018 0 0 1 5.156 2.218.625.625 0 1 0 1.25.036A4.29 4.29 0 0 0 11.25 7.5a4.27 4.27 0 0 0-6.037 0L2.5 10.215a4.267 4.267 0 0 0 6.031 6.035l.86-.86a.625.625 0 0 0-.875-.885"
  })));
};
export default SvgTypeLinkSizesWeightoutlined;